const state = {
  // 员工校验规则
  rules: (form) => {
    function validTenantName (rule, value, callback) {
      console.log(value, 'tenant name')
      if (/^\s.*$/.test(value)) {
        callback(new Error('不支持空格开头'))
      } else if (/[^0-9a-zA-Z\u4e00-\u9fa5\s]+/.test(value)) {
        callback(new Error('仅支持中英文、数字'))
      } else {
        callback()
      }
    }

    function validContactName (rule, value, callback) {
      if (/^\s.*$/.test(value)) {
        callback(new Error('不支持空格开头'))
      } else if (!/^[a-zA-Z0-9\u4e00-\u9fa5\s]+$/.test(value)) {
        callback(new Error('不支持特殊字符'))
      } else {
        callback()
      }
    }

    // function isValidPhone (str) {
    //   // const reg = /^(0|86|17951)?(13[0-9]|14[0-9]|15[0-9]|16[0-9]|17[0-9]|18[0-9]|19[0-9])[0-9]{8}$/
    //   const reg = /^(13[0-9]|14[0-9]|15[0-9]|16[0-9]|17[0-9]|18[0-9]|19[0-9])[0-9]{8}$/
    //   return reg.test(str)
    // }

    function validContactPhone (rule, value, callback) {
      console.log(value, 'phone')
      if (/^[-\s].*$/.test(value)) {
        callback(new Error('仅支持数字开头'))
      } else if (/^.*[-\s]$/.test(value)) {
        callback(new Error('仅支持数字结尾'))
      } else if (/[^0-9-\s]+$/.test(value)) {
        callback(new Error('仅支持数字、空格、-'))
      } else {
        callback()
      }
    }

    function validAccountMark (rule, value, callback) {
      if (/^\s.*$/.test(value)) {
        callback(new Error('不支持空格开头'))
      } else if (!/^[a-zA-Z0-9]*$/.test(value)) {
        callback(new Error('仅支持英文、数字'))
      } else {
        callback()
      }
    }

    function validAccountName (rule, value, callback) {
      if (!/^[0-9a-zA-Z.]+$/.test(value)) {
        callback(new Error('不支持特殊字符'))
      } else {
        callback()
      }
    }
    // function validEmail (rule, value, callback) {
    //   if (!/^\w+@[a-zA-Z0-9]{2,20}(?:\.[a-z]{2,4}){1,3}$/.test(value)) {
    //     callback(new Error('请输入正确的邮箱'))
    //   } else {
    //     callback()
    //   }
    // }

    function validPlace (rule, value, callback) {
      console.log(value, 'validate place')
      if (!value || !value.length) {
        callback(new Error('请选择租赁场所'))
      } else {
        callback()
      }
    }

    return {
      "name": [
        {required: true, message: '请输入租户名称', trigger: 'blur'},
        {min: 2, message: '字数控制在2到20个字符', trigger: 'blur'},
        {max: 20, message: '字数控制在2到20个字符', trigger: 'blur'},
        {validator: validTenantName, trigger: 'blur'}
      ],
      "place": [
        {required: true, message: '请选择租赁场所', trigger: ['blur', 'change']},
        {validator: validPlace, trigger: ['blur', 'change']}
      ],
      "dateRange": [
        {required: true, message: '请选择租赁时间', trigger: ['blur', 'change']}
      ],
      "contact": [
        {required: true, message: '请输入联系人姓名', trigger: 'blur'},
        {max: 30, message: '不超过30字符', trigger: 'blur'},
        {validator: validContactName, trigger: 'blur'}
      ],
      "phone": [
        {required: true, message: '请输入联系电话', trigger: 'blur'},
        {validator: validContactPhone, trigger: 'blur'}
      ],
      "accountMark": [
        {required: true, message: '请输入租户标识', trigger: 'blur'},
        {min: 2, message: '不少于2字符', trigger: 'blur'},
        {max: 20, message: '不超过20字符', trigger: 'blur'},
        {validator: validAccountMark, trigger: 'blur'}
      ],
      "accountName": [
        {required: true, message: '请输入账号', trigger: 'blur'},
        {validator: validAccountName, trigger: 'blur'}
      ]
      // "role": [
      //   {required: true, message: '请选择角色', trigger: ['blur', 'change']}
      // ]
      // "permission": [
      //   {required: true, message: '请选择权限', trigger: ['blur', 'change']}
      // ]
    }
  }
}

const actions = {
  checkPhone ({commit}, object) {
    if (object.value === '' || object.value === null) {
      object.callback()
    }
    let reg = /^1[0-9]{10}$/
    if (reg.test(object.value)) {
      object.callback()
    } else {
      object.callback(new Error('手机格式不正确'))
    }
  },
  // 校验必填项与空格
  checkRequiredAndSpace ({commit}, object) {
    let temp = object.value.toString()
    if (object.value === '' || object.value === null) {
      object.callback('不能为空')
    } else if (object.value.indexOf(' ') >= 0) {
      object.callback('输入字符中不能有空格')
    } else if (temp.length > 25) {
      object.callback('输入过长')
    } else {
      object.callback()
    }
  },
  // 校验正整数 非必填项
  checkPositiveInteger ({commit}, object) {
    let regu = /^[1-9]\d*$/
    if (object.value !== '') {
      if (!regu.test(object.value)) {
        object.callback('必须为正整数')
      } else {
        object.callback()
      }
    } else {
      object.callback()
    }
  },
  // 校验非负整数 非必填项
  checkNonnegativeInteger ({commit}, object) {
    let regu = /^(0|[1-9]\d*)$/
    if (object.value !== '') {
      if (!regu.test(object.value)) {
        object.callback('必须为非负整数')
      } else {
        object.callback()
      }
    } else {
      object.callback()
    }
  },

  // 校验正整数与空格 必填项
  checkPositiveIntegerAndSpace ({commit}, object) {
    if (object.value === '' || object.value === null) {
      object.callback('不能为空')
    } else if (isNaN(object.value) || !/^[0-9]*[1-9][0-9]*$/.test(object.value)) {
      object.callback('请输入正整数')
    } else if (object.value.toString().indexOf(' ') >= 0) {
      object.callback('输入字符中不能有空格')
    } else {
      object.callback()
    }
  },

  // 校验只能是数字、汉字和字母与空格与输入过长
  checkNumberOrSinogramOrLetterAndSpace ({commit}, object) {
    let temp = object.value.toString()
    let regu = /^[A-Za-z0-9\u4e00-\u9fa5]+$/
    if (object.value === '' || object.value === null) {
      object.callback('不能为空')
    } else if (object.value.indexOf(' ') >= 0) {
      object.callback('输入字符中不能有空格')
    } else if (temp.length > 25) {
      object.callback('输入过长')
    } else if (!regu.test(object.value)) {
      object.callback('只能是数字、汉字和字母')
    } else {
      object.callback()
    }
  }
}

export default {
  namespaced: true,
  state,
  actions
}



// WEBPACK FOOTER //
// ./src/store/validateTenancy.js